/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSagittarius: {
  name: 'sagittarius';
  data: string;
} = {
  name: 'sagittarius',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m320.265 549.388-95.641-95.719-119.908 119.675-68.751-68.751 119.83-119.83c-72.281-72.389-92.219-92.43-95.418-95.719l68.751-68.757 95.568 95.569L377.73 162.822c-164.795-41.188-127.791-32.061-133.552-33.582L267.7 34.898l243.623 60.736 59.798 243.395-94.661 23.6-31.988-128.609L293.61 384.757l95.647 95.647-68.992 68.984z"/></svg>`,
};
